const moneyTransferVisuals = [
  {
    src: "/images/xe/case-studies/money-transfer/01-converter.png",
    alt: "XE mobile currency converter",
    caption: "Trusted converter experience",
  },
  {
    src: "/images/xe/case-studies/money-transfer/02-transfer-rates.png",
    alt: "XE converter showing international money transfer rates",
    caption: "Introducing transfer rates",
  },
  {
    src: "/images/xe/case-studies/money-transfer/03-send-money.png",
    alt: "XE mobile send money screen",
    caption: "Begin a money transfer",
  },
  {
    src: "/images/xe/case-studies/money-transfer/04-enter-amount.png",
    alt: "XE money transfer amount entry screen",
    caption: "Enter the transfer amount",
  },
  {
    src: "/images/xe/case-studies/money-transfer/05-recipient.png",
    alt: "XE money transfer recipient screen",
    caption: "Choose a recipient",
  },
];

export default moneyTransferVisuals;
